const PendingVerification = () => import("../components/pendingVerification.vue");


/* Exporting the object routes of home module. */
export default [
  {
    name: "pending-verification",
    path: "/pending-verification",
    meta: {
      Title: "Pending Verification",
      layout: "LoggedLayout",
      requireAuth: false
    },
    component: PendingVerification,
  },
];